// Compressor vertex schema
// Active gas device with pressure_ratio mode.

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema } from '../base/common';
import { CompressorOperationConfigSchema } from '../base/active-device-operation';
import { CompressorCurveSchema } from '../base/curves';

// --- Polytropic Exponent ---

const PolytropicExponentMethodSchema = z.enum([
  'calculate_n',
  'use_specific_heat_ratio',
  'entered_n',
]);

const PolytropicExponentSchema = z.object({
  method: PolytropicExponentMethodSchema,
  value: z.number().optional(),
});

export const CompressorVertexSchema = BaseVertexSchema.extend({
  type: z.literal('compressor'),
  elevation: ValueWithUnitSchema,
  compressor_curve: CompressorCurveSchema.optional(),
  operation: CompressorOperationConfigSchema,
  polytropic_exponent: PolytropicExponentSchema.optional(),
});

export type CompressorVertex = z.infer<typeof CompressorVertexSchema>;
